/* unplugin-vue-components disabled */import script from "./secondMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./secondMenu.vue?vue&type=script&setup=true&lang=js"

import "./secondMenu.vue?vue&type=style&index=0&id=3e5d30fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e5d30fa"]])

export default __exports__